import React, { forwardRef } from 'react';
import { backgroundColor, spacing, radius } from './../../theming';

const PageContainer = forwardRef(({ children, style, ...props }, ref) => {
    return (
        <div
            ref={ref}
            style={{
                backgroundColor: backgroundColor.white,
                padding: `${spacing[2]} ${spacing[5]}`,
                borderRadius: radius.md,
                ...style,
            }}
            {...props}
        >
            {children}
        </div>
    );
});

export default PageContainer;
